import React from "react";

const ExecuteReport = () => {
	return (
		<>
			<h1>ExecuteReport</h1>
		</>
	);
};

export { ExecuteReport };
